// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;He gives the beasts their food&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the young ravens when they cry.<br> </p> </div></div>";
// Exports
module.exports = code;